// ✅ CENTRAL PROPERTY CATEGORIES (English & Hindi)
export const PROPERTY_CATEGORIES = [
  { value: 'rent', label: '🏠 Rent / किराया', labelEn: '🏠 Rent', labelHi: '🏠 किराया', icon: '🏠', color: '#667eea' },
  { value: 'house', label: '🏡 House / मकान', labelEn: '🏡 House', labelHi: '🏡 मकान', icon: '🏡', color: '#667eea' },
  { value: 'plot', label: '📍 Plot / प्लॉट', labelEn: '📍 Plot', labelHi: '📍 प्लॉट', icon: '📍', color: '#667eea' },
  { value: 'agriculture', label: '🌾 Agriculture / कृषि', labelEn: '🌾 Agriculture', labelHi: '🌾 कृषि', icon: '🌾', color: '#667eea' },
  { value: 'commercial', label: '🏢 Commercial / वाणिज्यिक', labelEn: '🏢 Commercial', labelHi: '🏢 वाणिज्यिक', icon: '🏢', color: '#667eea' },
  { value: 'industrial', label: '🏭 Industrial / औद्योगिक', labelEn: '🏭 Industrial', labelHi: '🏭 औद्योगिक', icon: '🏭', color: '#667eea' },
  { value: 'warehouse', label: '📦 Warehouse / गोदाम', labelEn: '📦 Warehouse', labelHi: '📦 गोदाम', icon: '📦', color: '#667eea' },
  { value: 'office', label: '🏢 Office / कार्यालय', labelEn: '🏢 Office', labelHi: '🏢 कार्यालय', icon: '🏢', color: '#667eea' },
  { value: 'shop', label: '🛍️ Shop / दुकान', labelEn: '🛍️ Shop', labelHi: '🛍️ दुकान', icon: '🛍️', color: '#667eea' },
];

// ✅ CENTRAL SERVICE CATEGORIES (English & Hindi)
export const SERVICE_CATEGORIES = [
  // Construction & Building Services
  { value: 'RAJ-MISTRI', labelEn: '🏗️ RAJ-MISTRI (Mason)', labelHi: '🏗️ राज-मिस्त्री (मेसन)' },
  { value: 'PLUMBER', labelEn: '🚰 PLUMBER', labelHi: '🚰 प्लंबर' },
  { value: 'ELECTRICIAN', labelEn: '⚡ ELECTRICIAN', labelHi: '⚡ विद्युत मिस्त्री' },
  { value: 'CARPENTER', labelEn: '🪑 CARPENTER', labelHi: '🪑 बढ़ई' },
  { value: 'PAINTER', labelEn: '🎨 PAINTER', labelHi: '🎨 पेंटर' },
  { value: 'WELDER', labelEn: '🔥 WELDER', labelHi: '🔥 वेल्डर' },
  { value: 'MECHANIC', labelEn: '🔧 MECHANIC', labelHi: '🔧 मैकेनिक' },
  { value: 'PLUMBER-ASSISTANT', labelEn: '🚰 PLUMBER ASSISTANT', labelHi: '🚰 प्लंबर सहायक' },
  { value: 'ELECTRICIAN-ASSISTANT', labelEn: '⚡ ELECTRICIAN ASSISTANT', labelHi: '⚡ विद्युत सहायक' },
  { value: 'TILER', labelEn: '🟦 TILER', labelHi: '🟦 टाइलर' },
  { value: 'CONCRETE-WORKER', labelEn: '🏢 CONCRETE WORKER', labelHi: '🏢 कंक्रीट कार्यकर्ता' },
  { value: 'MARBLE-SPECIALIST', labelEn: '🪨 MARBLE SPECIALIST', labelHi: '🪨 संगमरमर विशेषज्ञ' },
  { value: 'WOOD-WORKER', labelEn: '🪵 WOOD WORKER', labelHi: '🪵 लकड़ी का कार्यकर्ता' },
  
  // Technical & Engineering Services
  { value: 'GENERATOR-TECH', labelEn: '⚙️ GENERATOR TECHNICIAN', labelHi: '⚙️ जनरेटर तकनीशियन' },
  { value: 'PUMP-INSTALLER', labelEn: '💧 PUMP INSTALLER', labelHi: '💧 पंप इंस्टालर' },
  { value: 'AC-TECHNICIAN', labelEn: '❄️ AC TECHNICIAN', labelHi: '❄️ एसी तकनीशियन' },
  { value: 'FITTER', labelEn: '🔩 FITTER', labelHi: '🔩 फिटर' },
  { value: 'BLACKSMITH', labelEn: '⚒️ BLACKSMITH', labelHi: '⚒️ लुहार' },
  { value: 'LOCKSMITH', labelEn: '🔐 LOCKSMITH', labelHi: '🔐 ताली मिस्त्री' },
  { value: 'SOLAR-TECH', labelEn: '☀️ SOLAR TECHNICIAN', labelHi: '☀️ सौर तकनीशियन' },
  
  // Electronics & Appliances
  { value: 'MOBILE-REPAIRER', labelEn: '📱 MOBILE REPAIRER', labelHi: '📱 मोबाइल मरम्मत' },
  { value: 'COOLER-REPAIR', labelEn: '❄️ COOLER REPAIR', labelHi: '❄️ कूलर मरम्मत' },
  { value: 'REFRIGERATOR-TECH', labelEn: '🧊 REFRIGERATOR TECHNICIAN', labelHi: '🧊 रेफ्रिजरेटर तकनीशियन' },
  { value: 'WATER-PURIFIER', labelEn: '💧 WATER PURIFIER TECH', labelHi: '💧 जल शोधक तकनीशियन' },
  { value: 'TV-REPAIR', labelEn: '📺 TV REPAIR', labelHi: '📺 टीवी मरम्मत' },
  { value: 'COMPUTER-REPAIR', labelEn: '💻 COMPUTER REPAIR', labelHi: '💻 कंप्यूटर मरम्मत' },
  
  // Pest Control & Cleaning
  { value: 'PEST-CONTROL', labelEn: '🦟 PEST CONTROL', labelHi: '🦟 कीट नियंत्रण' },
  { value: 'CLEANING-SERVICE', labelEn: '🧹 CLEANING SERVICE', labelHi: '🧹 सफाई सेवा' },
  
  // Agriculture & Gardening
  { value: 'GARDENER', labelEn: '🌿 GARDENER', labelHi: '🌿 माली' },
  { value: 'AGRICULTURE-EXPERT', labelEn: '🌾 AGRICULTURE EXPERT', labelHi: '🌾 कृषि विशेषज्ञ' },
  { value: 'FARMER', labelEn: '👨‍🌾 FARMER', labelHi: '👨‍🌾 किसान' },
  
  // Medical & Health Services
  { value: 'DOCTOR', labelEn: '👨‍⚕️ DOCTOR', labelHi: '👨‍⚕️ डॉक्टर' },
  { value: 'NURSE', labelEn: '👩‍⚕️ NURSE', labelHi: '👩‍⚕️ नर्स' },
  { value: 'DENTIST', labelEn: '🦷 DENTIST', labelHi: '🦷 दंत चिकित्सक' },
  { value: 'VETERINARY', labelEn: '🐾 VETERINARY', labelHi: '🐾 पशु चिकित्सक' },
  { value: 'PHYSIOTHERAPIST', labelEn: '🏥 PHYSIOTHERAPIST', labelHi: '🏥 फिजियोथेरेपिस्ट' },
  { value: 'AYURVEDA-SPECIALIST', labelEn: '🌿 AYURVEDA SPECIALIST', labelHi: '🌿 आयुर्वेद विशेषज्ञ' },
  { value: 'HOMEOPATH', labelEn: '💊 HOMEOPATH', labelHi: '💊 होम्योपैथ' },
  
  // Education & Coaching
  { value: 'TUTOR', labelEn: '📚 TUTOR', labelHi: '📚 ट्यूटर' },
  { value: 'SCHOOL-TEACHER', labelEn: '🏫 SCHOOL TEACHER', labelHi: '🏫 स्कूल शिक्षक' },
  { value: 'ENGLISH-TEACHER', labelEn: '🇬🇧 ENGLISH TEACHER', labelHi: '🇬🇧 अंग्रेजी शिक्षक' },
  { value: 'HINDI-TEACHER', labelEn: '🇮🇳 HINDI TEACHER', labelHi: '🇮🇳 हिंदी शिक्षक' },
  { value: 'MATH-TEACHER', labelEn: '🔢 MATH TEACHER', labelHi: '🔢 गणित शिक्षक' },
  { value: 'SCIENCE-TEACHER', labelEn: '🧪 SCIENCE TEACHER', labelHi: '🧪 विज्ञान शिक्षक' },
  { value: 'COMPUTER-TEACHER', labelEn: '💻 COMPUTER TEACHER', labelHi: '💻 कंप्यूटर शिक्षक' },
  { value: 'COACHING-CENTER', labelEn: '📖 COACHING CENTER', labelHi: '📖 कोचिंग सेंटर' },
  { value: 'ONLINE-TEACHER', labelEn: '🖥️ ONLINE TEACHER', labelHi: '🖥️ ऑनलाइन शिक्षक' },
  
  // Retail & Shopping
  { value: 'SHOP-OWNER', labelEn: '🛍️ SHOP OWNER', labelHi: '🛍️ दुकान मालिक' },
  { value: 'GROCERY-SHOP', labelEn: '🛒 GROCERY SHOP', labelHi: '🛒 किराना दुकान' },
  { value: 'CLOTHING-STORE', labelEn: '👔 CLOTHING STORE', labelHi: '👔 कपड़ों की दुकान' },
  { value: 'MOBILE-SHOP', labelEn: '📱 MOBILE SHOP', labelHi: '📱 मोबाइल दुकान' },
  { value: 'ELECTRONICS-SHOP', labelEn: '⚡ ELECTRONICS SHOP', labelHi: '⚡ इलेक्ट्रॉनिक्स दुकान' },
  { value: 'HARDWARE-STORE', labelEn: '🔨 HARDWARE STORE', labelHi: '🔨 हार्डवेयर स्टोर' },
  { value: 'PHARMACY', labelEn: '💊 PHARMACY', labelHi: '💊 फार्मेसी' },
  { value: 'BOOKSTORE', labelEn: '📚 BOOKSTORE', labelHi: '📚 किताबों की दुकान' },
  { value: 'JEWELRY-SHOP', labelEn: '💍 JEWELRY SHOP', labelHi: '💍 जेवरात की दुकान' },
  
  // Fitness & Wellness
  { value: 'YOGA-INSTRUCTOR', labelEn: '🧘 YOGA INSTRUCTOR', labelHi: '🧘 योग प्रशिक्षक' },
  { value: 'FITNESS-TRAINER', labelEn: '💪 FITNESS TRAINER', labelHi: '💪 फिटनेस प्रशिक्षक' },
  { value: 'GYM-OWNER', labelEn: '🏋️ GYM OWNER', labelHi: '🏋️ जिम मालिक' },
  { value: 'DIETICIAN', labelEn: '🥗 DIETICIAN', labelHi: '🥗 आहार विशेषज्ञ' },
  
  // Beauty & Personal Care
  { value: 'HAIR-DRESSER', labelEn: '💇 HAIR DRESSER', labelHi: '💇 बाल काटने वाला' },
  { value: 'BEAUTICIAN', labelEn: '💄 BEAUTICIAN', labelHi: '💄 ब्यूटीशियन' },
  { value: 'SALON', labelEn: '💅 SALON', labelHi: '💅 सैलून' },
  { value: 'MASSAGE-THERAPIST', labelEn: '💆 MASSAGE THERAPIST', labelHi: '💆 मसाज थेरेपिस्ट' },
  
  // Tailoring & Fashion
  { value: 'TAILOR', labelEn: '👗 TAILOR', labelHi: '👗 दर्जी' },
  { value: 'SHOE-MAKER', labelEn: '👞 SHOE MAKER', labelHi: '👞 जूते बनाने वाला' },
  { value: 'DESIGNER', labelEn: '🎨 DESIGNER', labelHi: '🎨 डिजाइनर' },
  
  // Automotive Services
  { value: 'CAR-WASH', labelEn: '🚗 CAR WASH', labelHi: '🚗 कार वाश' },
  { value: 'CAR-REPAIR', labelEn: '🔧 CAR REPAIR', labelHi: '🔧 कार मरम्मत' },
  { value: 'BIKE-REPAIR', labelEn: '🏍️ BIKE REPAIR', labelHi: '🏍️ बाइक मरम्मत' },
  { value: 'AUTO-SPARE-PARTS', labelEn: '⚙️ AUTO SPARE PARTS', labelHi: '⚙️ ऑटो स्पेयर पार्ट्स' },
  { value: 'PETROL-PUMP', labelEn: '⛽ PETROL PUMP', labelHi: '⛽ पेट्रोल पंप' },
  
  // Laundry & Delivery
  { value: 'LAUNDRY-SERVICE', labelEn: '👕 LAUNDRY SERVICE', labelHi: '👕 लांड्री सेवा' },
  { value: 'COURIER-SERVICE', labelEn: '📦 COURIER SERVICE', labelHi: '📦 कूरियर सेवा' },
  { value: 'DELIVERY-SERVICE', labelEn: '🚚 DELIVERY SERVICE', labelHi: '🚚 डिलीवरी सेवा' },
  
  // Printing & Design
  { value: 'PRINTING-SERVICE', labelEn: '🖨️ PRINTING SERVICE', labelHi: '🖨️ प्रिंटिंग सेवा' },
  { value: 'GRAPHIC-DESIGNER', labelEn: '🎨 GRAPHIC DESIGNER', labelHi: '🎨 ग्राफिक डिजाइनर' },
  
  // Photography & Media
  { value: 'PHOTOGRAPHY', labelEn: '📸 PHOTOGRAPHY', labelHi: '📸 फोटोग्राफी' },
  { value: 'VIDEOGRAPHY', labelEn: '🎥 VIDEOGRAPHY', labelHi: '🎥 वीडियोग्राफी' },
  { value: 'VIDEO-EDITOR', labelEn: '✂️ VIDEO EDITOR', labelHi: '✂️ वीडियो संपादक' },
  
  // Entertainment & Arts
  { value: 'MUSIC-LESSONS', labelEn: '🎵 MUSIC LESSONS', labelHi: '🎵 संगीत पाठ' },
  { value: 'MUSIC-TEACHER', labelEn: '🎸 MUSIC TEACHER', labelHi: '🎸 संगीत शिक्षक' },
  { value: 'DANCE-LESSONS', labelEn: '💃 DANCE LESSONS', labelHi: '💃 नृत्य पाठ' },
  { value: 'DANCE-TEACHER', labelEn: '🩰 DANCE TEACHER', labelHi: '🩰 नृत्य शिक्षक' },
  { value: 'ACTING-COACH', labelEn: '🎭 ACTING COACH', labelHi: '🎭 अभिनय कोच' },
  
  // Food & Catering
  { value: 'COOKING-CLASS', labelEn: '👨‍🍳 COOKING CLASS', labelHi: '👨‍🍳 खाना पकाने की कक्षा' },
  { value: 'CHEF', labelEn: '🍳 CHEF', labelHi: '🍳 शेफ' },
  { value: 'CATERER', labelEn: '🍽️ CATERER', labelHi: '🍽️ कैटरर' },
  { value: 'RESTAURANT', labelEn: '🍴 RESTAURANT', labelHi: '🍴 रेस्तरां' },
  { value: 'BAKERY', labelEn: '🍰 BAKERY', labelHi: '🍰 बेकरी' },
  { value: 'SALON', labelEn: '💅 SALON', labelHi: '💅 सैलून' },
  { value: 'BEAUTY-PARLOR', labelEn: '💇‍♀️ BEAUTY PARLOR', labelHi: '💇‍♀️ ब्यूटी पार्लर' },
  { value: 'MAKEUP-ARTIST', labelEn: '💄 MAKEUP ARTIST', labelHi: '💄 मेकअप आर्टिस्ट' },
  { value: 'MASSAGE-THERAPIST', labelEn: '💆 MASSAGE THERAPIST', labelHi: '💆 मसाज थेरेपिस्ट' },



  
  // General
  { value: 'OTHER', labelEn: '📋 OTHER', labelHi: '📋 अन्य' },
  
];

// ✅ HELPER FUNCTIONS
export const getCategoryLabel = (value, type = 'service', language = 'en') => {
  const categories = type === 'property' ? PROPERTY_CATEGORIES : SERVICE_CATEGORIES;
  const category = categories.find(cat => cat.value === value);
  
  if (!category) return value;
  
  if (language === 'hi') {
    return category.labelHi || category.label || value;
  }
  return category.labelEn || category.label || value;
};

export const getCategoryIcon = (value, type = 'property') => {
  const categories = type === 'property' ? PROPERTY_CATEGORIES : SERVICE_CATEGORIES;
  const category = categories.find(cat => cat.value === value);
  const label = category ? (category.labelEn || category.label) : '📋';
  return label.split(' ')[0];
};

// ✅ GET ALL LABELS (for display)
export const getAllLabels = (value, type = 'service') => {
  const categories = type === 'property' ? PROPERTY_CATEGORIES : SERVICE_CATEGORIES;
  const category = categories.find(cat => cat.value === value);
  return {
    en: category?.labelEn || category?.label || value,
    hi: category?.labelHi || value,
  };
};

// ✅ GET CATEGORY COLOR
export const getCategoryColor = (value, type = 'property') => {
  const categories = type === 'property' ? PROPERTY_CATEGORIES : SERVICE_CATEGORIES;
  const category = categories.find(cat => cat.value === value);
  return category?.color || '#667eea';
};

// ✅ GET ALL SERVICE CATEGORIES
export const getAllServiceCategories = () => {
  return SERVICE_CATEGORIES;
};

// ✅ GET ALL PROPERTY CATEGORIES
export const getAllPropertyCategories = () => {
  return PROPERTY_CATEGORIES;
};

// ✅ GET CATEGORIES BY TYPE (grouped)
export const getCategoriesByGroup = () => {
  return {
    construction: SERVICE_CATEGORIES.filter(c => ['RAJ-MISTRI', 'PLUMBER', 'ELECTRICIAN', 'CARPENTER', 'PAINTER', 'WELDER', 'TILER', 'MARBLE-SPECIALIST', 'WOOD-WORKER'].includes(c.value)),
    technical: SERVICE_CATEGORIES.filter(c => ['GENERATOR-TECH', 'PUMP-INSTALLER', 'AC-TECHNICIAN', 'FITTER', 'SOLAR-TECH'].includes(c.value)),
    medical: SERVICE_CATEGORIES.filter(c => ['DOCTOR', 'NURSE', 'DENTIST', 'VETERINARY', 'PHYSIOTHERAPIST', 'AYURVEDA-SPECIALIST', 'HOMEOPATH'].includes(c.value)),
    education: SERVICE_CATEGORIES.filter(c => ['TUTOR', 'SCHOOL-TEACHER', 'ENGLISH-TEACHER', 'HINDI-TEACHER', 'MATH-TEACHER', 'SCIENCE-TEACHER', 'COMPUTER-TEACHER', 'COACHING-CENTER', 'ONLINE-TEACHER'].includes(c.value)),
    shopping: SERVICE_CATEGORIES.filter(c => ['SHOP-OWNER', 'GROCERY-SHOP', 'CLOTHING-STORE', 'MOBILE-SHOP', 'ELECTRONICS-SHOP', 'HARDWARE-STORE', 'PHARMACY', 'BOOKSTORE', 'JEWELRY-SHOP'].includes(c.value)),
    fitness: SERVICE_CATEGORIES.filter(c => ['YOGA-INSTRUCTOR', 'FITNESS-TRAINER', 'GYM-OWNER', 'DIETICIAN'].includes(c.value)),
    beauty: SERVICE_CATEGORIES.filter(c => ['HAIR-DRESSER', 'BEAUTICIAN', 'SALON', 'MASSAGE-THERAPIST'].includes(c.value)),
    automotive: SERVICE_CATEGORIES.filter(c => ['CAR-WASH', 'CAR-REPAIR', 'BIKE-REPAIR', 'AUTO-SPARE-PARTS', 'PETROL-PUMP'].includes(c.value)),
    food: SERVICE_CATEGORIES.filter(c => ['COOKING-CLASS', 'CHEF', 'CATERER', 'RESTAURANT', 'BAKERY'].includes(c.value)),
  };
};